import {create} from 'zustand';

const useReportProfile = create((set) => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));


export default useReportProfile;